// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2rqMh","logo":"styles_logo__7iut9","formName":"styles_formName__37QDm","disabledFormName":"styles_disabledFormName__3l2-u"};